import { render } from "./self-assessment-v2.vue?vue&type=template&id=05229d11&scoped=true"
import script from "./self-assessment-v2.vue?vue&type=script&lang=js"
export * from "./self-assessment-v2.vue?vue&type=script&lang=js"

import "./self-assessment-v2.vue?vue&type=style&index=0&id=05229d11&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05229d11"]])

export default __exports__